import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { IconDeprecated, IconSize, IconType } from '../../misc/IconDeprecated/IconDeprecated';
import { prepareProps } from '../../utils/propUtils';
import { BaseDialogButton, BaseDialogButtonProps } from '../BaseDialogButton/BaseDialogButton';
export type BaseDialogIconButtonProps = BaseDialogButtonProps & {
  iconName: string;
  iconType: IconType;
};
export const BaseDialogIconButton: FunctionComponent<BaseDialogIconButtonProps> = React.memo(props => {
  const $ = _c(12);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let iconName;
  let iconType;
  let remainingProps;
  if ($[2] !== t0) {
    ({
      iconName,
      iconType,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = iconName;
    $[4] = iconType;
    $[5] = remainingProps;
  } else {
    iconName = $[3];
    iconType = $[4];
    remainingProps = $[5];
  }
  let t1;
  if ($[6] !== iconName || $[7] !== iconType) {
    t1 = <IconDeprecated name={iconName} type={iconType} size={IconSize.Large} />;
    $[6] = iconName;
    $[7] = iconType;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== remainingProps || $[10] !== t1) {
    t2 = <BaseDialogButton {...remainingProps}>{t1}</BaseDialogButton>;
    $[9] = remainingProps;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
});